var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuestic-widget',{attrs:{"header-text":"403!!!!"}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"container--title"},[_vm._v("403 - NO TIENE ACCESO")]),_c('img',{attrs:{"src":"","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }